import React from "react";
import { HiMiniArrowLongDown } from "react-icons/hi2";
import { IoIosArrowDown } from "react-icons/io";

const orgData = {
  title: "HUD & PHE DEPTT. GOVT. OF PUNJAB",
  children: [
    {
      title: "RDA GOVERNING BODY",
      children: [
        {
          title: "DG RDA",
          children: [
            {
              title: "ADDITIONAL DG RDA",
              children: [
                {
                  title: "CHIEF PLANNER",
                  children: [
                    {
                      title: "DIRECTOR MP & TE",
                    },

                    {
                      title: "DIRECTOR LU & BC",
                    },
                    { title: "DIRECTOR ARCH." },
                  ],
                },
                {
                  title: "DIRECTOR ADMIN",
                },
                {
                  title: "DIRECTOR FINANCE",
                },
                {
                  title: "DIRECTOR LD",
                },
                {
                  title: "DIRECTOR EM",
                },
                {
                  title: "CHIEF ENGINEER",
                  children: [
                    { title: "DIRECTOR ENGG. I" },
                    { title: "DIRECTOR ENGG. II" },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

const TreeNode = ({ node }) => {
  const [open, setOpen] = React.useState(true);

  const isAdditionalDG = node.title === "ADDITIONAL DG RDA";
  const isCHIEFPLANNER = node.title === "CHIEF PLANNER";
  const isCHIEFENGINEER = node.title === "CHIEF ENGINEER";

  return (
    <div className="flex flex-col items-center md:p-2 p-1">
      <div
        className={`cursor-pointer  ${
          node.title === "HUD & PHE DEPTT. GOVT. OF PUNJAB"
            ? "bg-[#00643aea] hover:bg-[#00643B] text-white"
            : ["RDA GOVERNING BOD", "DG RDA", "ADDITIONAL DG RDA"].includes(
                node.title
              )
            ? "bg-[#FAFAFA] hover:bg-[#c2c1c1] text-[#00643b]"
            : "bg-[#FAFAFA] hover:bg-[#c2c1c1] text-[#393939]"
        }  transition md:rounded-xl rounded-md shadow-md lg:px-4 md:px-3 px-2 md:py-2 p-1 text-center  lg:text-base md:text-sm sm:text-[12px] text-[10px]  font-semibold flex items-center md:gap-2 gap-1`}
        onClick={() => setOpen(!open)}
      >
        <span>{node.title}</span>
        {node.children && (
          <IoIosArrowDown
            className={`md:size-4 size-3 transition-transform ${
              open ? "rotate-180" : "rotate-0"
            }`}
          />
        )}
      </div>

      {open && node.children && (
        <div className="flex flex-col items-center">
          {(isAdditionalDG || isCHIEFENGINEER || isCHIEFPLANNER) && (
            <div className="flex w-full justify-center relative">
              <div className="absolute top-[18px] h-0.5 bg-[#393939] w-[90%] rounded-xl"></div>
            </div>
          )}

          <div className="mt-4 flex flex-row space-x-4 ">
            {node.children.map((child, index) => (
              <div key={index} className="flex flex-col items-center">
                <HiMiniArrowLongDown className=" md:size-8 size-6 text-[#393939]" />
                <TreeNode node={child} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default function Organogram() {
  return (
    <div className="min-h-screen bg-white ">
      <h1 className="bg-green-900  lg:text-2xl md:text-xl text-base  text-white font-bold mb-6 lg:p-4 md:p-3 p-2 text-left">
        ORGANOGRAM
      </h1>
      <div className="overflow-x-auto w-full">
        <div className="flex justify-center min-w-[768px] mx-auto mb-6 ">
          <TreeNode node={orgData} />
        </div>
      </div>
    </div>
  );
}
